// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604071317/js/" + chunkId + "." + {"44":"fea846a3","225":"f02aa748","481":"63c994c6","486":"0610fd6e","770":"70a24048"}[chunkId] + ".0.525997397761564.chunk.js";
};